var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12ZM3.80078 4.40039C3.5799 4.40039 3.40044 4.57894 3.40039 4.7998V12.2002C3.40055 12.421 3.57997 12.5996 3.80078 12.5996H12.2002C12.421 12.5996 12.6004 12.421 12.6006 12.2002V4.7998C12.6005 4.57894 12.4211 4.40039 12.2002 4.40039H3.80078Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 0.4,
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.9C10 5.67909 10.1791 5.5 10.4 5.5H11.6C11.8209 5.5 12 5.67909 12 5.9V7.1C12 7.32091 11.8209 7.5 11.6 7.5H10.4C10.1791 7.5 10 7.32091 10 7.1V5.9Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOtl);
export default __webpack_public_path__ + "static/media/Calendar_otl.a44548dd81cdc7c7e65ff833b5382178.svg";
export { ForwardRef as ReactComponent };